$(document).ready(function () {

    const $ticker = $('.topbar__inner');

    let speed = 0.5;
    let position = 0;
    let paused = false;

    const items = $ticker.html();
    $ticker.html(`
    <div class="ticker-track">
      ${items}
      ${items}
    </div>
  `);

    const $track = $('.ticker-track');

    $('.topbar').hover(
        () => paused = true,
        () => paused = false
    );

    function animate() {
        if (!paused) {
            position -= speed;

            if (Math.abs(position) >= $track.width() / 2) {
                position = 0;
            }

            $track.css('transform', `translateX(${position}px)`);
        }

        requestAnimationFrame(animate);
    }

    animate();

    function pad(n) {
        return n.toString().padStart(2, '0');
    }

    function getNextCutoff(now) {
        const cutoffHour = 17;
        let target = new Date(now);

        const day = now.getDay();
        const hour = now.getHours();

        if (day >= 1 && day <= 4) {
            if (hour < cutoffHour) {
                target.setHours(cutoffHour, 0, 0, 0);
            } else {
                target.setDate(target.getDate() + 1);
                target.setHours(cutoffHour, 0, 0, 0);
            }
        } else if (day === 5) {
            if (hour < cutoffHour) {
                target.setHours(cutoffHour, 0, 0, 0);
            } else {
                target.setDate(target.getDate() + 3);
                target.setHours(cutoffHour, 0, 0, 0);
            }
        } else if (day === 6) {
            target.setDate(target.getDate() + 2);
            target.setHours(cutoffHour, 0, 0, 0);
        } else {
            target.setDate(target.getDate() + 1);
            target.setHours(cutoffHour, 0, 0, 0);
        }

        return target;
    }

    function updateCountdown() {
        const now = new Date();
        const cutoff = getNextCutoff(now);

        const diff = cutoff - now;

        if (diff <= 0) {
            $('#next-day-delivery-msg').text('Cutoff passed');
            return;
        }

        const hours = Math.floor(diff / 3600000);
        const minutes = Math.floor((diff % 3600000) / 60000);
        const seconds = Math.floor((diff % 60000) / 1000);

        $('#next-day-delivery-msg').text(
            `Order within ${pad(hours)}:${pad(minutes)}:${pad(seconds)} for Free delivery on orders over £100`
        );
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);

    $('.product-card__title').matchHeight();
    $(".filter-heading").on("click", function () {

        const $this = $(this);
        const $content = $this.next();

        if ($this.hasClass("active")) {
            $this.removeClass("active");
            $content.stop(true, true).slideUp(250).removeClass("open");
            return;
        }

        $(".filter-heading").removeClass("active");
        $(".filter-heading").next().stop(true, true).slideUp(250).removeClass("open");

        $this.addClass("active");
        $content.stop(true, true).slideDown(250).addClass("open");

    });
    $('.filter-button').on('click', function () {

        var modalID = $(this).data('modal');
        var $target = $('.modal[data-modal="' + modalID + '"]');

        $('.modal').not($target).removeClass('active');
        $target.toggleClass('active');

    });
    $('.product-page__main').owlCarousel({
        items: 1,
        nav: false,
        dots: false,
        autoHeight: false
    });

    $('.product-page__thumbs').owlCarousel({
        items: 3,
        margin: 10
    });
    $('.stories-cta__carousel').owlCarousel({
        items: 1,
        loop: true,
        margin: 0,
        nav: false,
        dots: true,
        autoplay: false,
        autoHeight: true
    });
    (function () {

        function getOffset() {
            var header = document.querySelector('.site-header');
            return header ? header.offsetHeight : 80;
        }

        function scrollToTarget(hash) {
            var target = document.querySelector(hash);
            if (!target) return;

            var y = target.getBoundingClientRect().top + window.pageYOffset - getOffset();

            window.scrollTo({
                top: y,
                behavior: 'smooth'
            });
        }

        document.addEventListener('click', function (e) {
            var link = e.target.closest('a');
            if (!link) return;

            var href = link.getAttribute('href');
            if (!href) return;

            var hash = href.includes('#') ? '#' + href.split('#')[1] : null;
            if (!hash || hash === '#') return;

            if (link.pathname === window.location.pathname) {
                var target = document.querySelector(hash);
                if (!target) return;

                e.preventDefault();

                scrollToTarget(hash);
                history.pushState(null, '', hash);
            }
        });

        window.addEventListener('load', function () {
            if (!window.location.hash) return;

            window.scrollTo(0, 0);

            setTimeout(function () {
                scrollToTarget(window.location.hash);
            }, 50);
        });

    })();
    $('.logo-carousel__inner').owlCarousel({
        loop: true,
        margin: 40,
        nav: false,
        dots: false,
        autoplay: true,
        autoplayTimeout: 3000,
        responsive: {
            0: {
                items: 2
            },
            768: {
                items: 3
            },
            1024: {
                items: 5
            }
        }
    });
    $('#range-carousel .range-carousel__slider').owlCarousel({
        loop: true,
        margin: 20,
        nav: false,
        dots: false,
        centerMode: true,
        stagePadding: 180,
        responsive: {
            0: {
                items: 1,
                stagePadding: 50,
            },
            768: {
                items: 2,
                stagePadding: 50,
            },
            1024: {
                items: 3,
                stagePadding: 180,
            }
        }
    });
    if ($('body').hasClass('template-page-screen')) {

        $('#products-carousel .range-carousel__slider').owlCarousel({
            loop: true,
            margin: 20,
            nav: false,
            dots: false,
            centerMode: true,
            stagePadding: 80,
            items: 1,
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: false
        });

    } else {

        $('#products-carousel .range-carousel__slider').owlCarousel({
            loop: true,
            margin: 20,
            nav: false,
            dots: false,
            centerMode: true,
            stagePadding: 180,
            responsive: {
                0: {
                    items: 1,
                    stagePadding: 50,
                },
                768: {
                    items: 2,
                    stagePadding: 50,
                },
                1024: {
                    items: 3,
                    stagePadding: 180,
                }
            }
        });

    };

    $('#customer-carousel .range-carousel__slider').owlCarousel({
        loop: true,
        margin: 20,
        nav: false,
        dots: false,
        centerMode: false,
        responsive: {
            0: {
                items: 1,
                centerMode: true,
                stagePadding: 50,
            },
            768: {
                items: 2
            },
            1024: {
                items: 4
            }
        }
    });
    $('.colours-carousel').owlCarousel({
        loop: true,
        margin: 10,
        nav: false,
        dots: false,
        responsive: {
            0: {
                items: 4
            },
            600: {
                items: 6
            },
            1000: {
                items: 8
            },
            1200: {
                items: 12
            }
        }
    });
    var $hamburger = $(".hamburger");
    $hamburger.on("click", function (e) {
        $hamburger.toggleClass("is-active");
        $('#mobile-menu').toggleClass('mm-active');
    });

    $('#mobile-menu .mm-has-children').each(function () {
        if ($(this).children('.mm-toggle-sub').length === 0) {
            $(this).children('a').after('<span class="mm-toggle-sub">+</span>');
        }
    });

    $('#mobile-menu').on('click', '.mm-toggle-sub', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const parent = $(this).closest('.mm-has-children');
        const submenu = parent.children('.mm-submenu');

        parent.toggleClass('mm-open');
        submenu.stop(true, true).slideToggle(200);

        $(this).text(parent.hasClass('mm-open') ? '−' : '+');

    });

    $('#mobile-menu').on('click', '.mm-has-children > a', function (e) {
        e.preventDefault();

        const parent = $(this).parent();
        const toggle = parent.children('.mm-toggle-sub');

        toggle.trigger('click');
    });

});